export default [
    {
      title: '数据概览',
      icon: 'el-icon-data-analysis',
      name: 'dashboard',
      component: () => import('@/views/Dashboard.vue'),
      closable: false
    },
    {
      title: '图表设置',
      icon: 'el-icon-tickets',
      name: 'clientConfig',
      component: () => import('@/views/ClientConfig.vue')
    },
    {
      title: '产品组管理',
      icon: 'el-icon-s-management',
      name: 'groups',
      component: () => import('@/views/Groups.vue')
    },
    // {
    //   title: '产品列表',
    //   icon: 'el-icon-goods',
    //   name: 'products',
    //   component: () => import('@/views/Products.vue')
    // },
    {
      title: '数据明细',
      icon: 'el-icon-s-order',
      name: 'details',
      component: () => import('@/views/Details.vue')
    },
    {
      title: '回调设置',
      icon: 'el-icon-s-marketing',
      name: 'callTransfromLimit',
      component: () => import('@/views/CallTransfromLimit.vue')
    },
    {
      title: '回调查询',
      icon: 'el-icon-s-promotion',
      name: 'callbackData',
      component: () => import('@/views/CallbackData.vue')
    }
  ]